<template>
  <div class="giac-footer-con">
    <div class="giac-footer pc" :class="'year_'+global.year">
      <div class="content">
        <div class="related-course">
          <h4>相关课程</h4>
          <div class="row">
            <a href="http://www.top100summit.com" target="_blank">年度案例研究峰会</a> 
            &nbsp; | &nbsp;
            <a href="https://www.msup.com.cn/course/index" target="_blank">经典公开课</a> 
          </div>
          <div class="row">
            <!-- <a href="http://old.msup.com.cn/bayarea" target="_blank">海外研修之旅</a> | -->
            <a href="http://a2m.msup.com.cn/" target="_blank">人工智能峰会</a> 
            &nbsp; | &nbsp;
            <a href="http://www.mpd.org.cn/" target="_blank">MPD工作坊</a> 
            &nbsp; | &nbsp;
          </div>
          <div class="row" style="display:flex;flex-wrap:nowrap;">
            <a href="http://giac.msup.com.cn" target="_blank">GIAC全球互联网架构大会&nbsp;</a>
            <a href="https://www.cnzz.com/stat/website.php?web_id=1274433542" target="_blank" title="站长统计">
              <img style="height:16px;margin-top:1px;border:none;" hspace="0" vspace="0" :src="iconImg">
            </a>
          </div>
        </div>
        <div class="contact-us pc">
          <h4>联系我们</h4>
          <p v-if="global.companyphone[0]!=1">详情咨询：{{global.companyphone}}</p>
          <p>赞助合作：sissi</p>
          <p>联系电话：130-4321-8801</p>
          <p>邮箱：market@msup.com.cn</p>
          <p>媒体合作：景怡</p>
          <p>联系电话：139-2085-9305</p>
          <p>邮箱：jingyi@msup.com.cn</p>
          <p>票务合作：祖丽</p>
          <p>联系电话：150-2204-3723</p>
          <p>邮箱：zuli@msup.com.cn</p>
        </div>
        <div class="sponsor">
          <h4>主办方</h4>
          <!-- <img src="../assets/img/footer_logo.png" alt="" /> -->
          <div class="qrcode-wrapper" style="margin-top:0;">
            <img src="../assets/img/footer_logo.png" :style="['2023sz'].includes(global.year)?'height:30px;':''" alt="" />
            <img v-if="global.year=='2022sz'" src="https://f.msup.com.cn/%E5%8D%8F%E4%BC%9Alogo%EF%BC%88%E6%96%B0%E7%89%88%EF%BC%89.png" style="height:43px;margin-left:15px;" alt="">
            <img v-if="['2023sz'].includes(global.year)" src="https://f.msup.com.cn/%E5%8D%8F%E4%BC%9Alogo%282023%29.png" style="height:30px;margin-left:15px;" alt="" >
          </div>
          <div class="qrcode-wrapper">
            <img src="../assets/img/footer_qrcode.png" alt="" />
            <p>关注微信公众账号 msupclub</p>
          </div>
        </div>
      </div>
      <div class="company">
        <p>
          CopyRight © 2008-{{new Date().getFullYear()}} Msup & 高可用架构 &nbsp;&nbsp;
          <a href="https://www.cnzz.com/stat/website.php?web_id=4006688" target="_blank" title="站长统计">
            <img style="height:16px;vertical-align:sub;border:none;" hspace="0" vspace="0" :src="iconImg">
          </a>
        </p>
        <a href="http://www.beian.miit.gov.cn">
          <img
            width="18"
            height="18"
            style="height: 18px; padding-bottom: 0px"
            src="https://f.msup.com.cn/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png" />
            京ICP备09001521号
          </a>
      </div>
    </div>
    <div class="giac-footer mob" :class="'year_'+global.year">
      <div class="content">
        <div class="sponsor">
          <h4>主办方</h4>
          <!-- <img class="logo" src="../assets/img/footer_logo.png" alt="" /> -->
          <div class="qrcode-wrapper" style="margin-top:0;">
            <img class="logo" :style="['2023sz'].includes(global.year)?'height:32px;':''" src="../assets/img/footer_logo.png" alt="" />
            <img v-if="global.year=='2022sz'" src="https://f.msup.com.cn/%E5%8D%8F%E4%BC%9Alogo%EF%BC%88%E6%96%B0%E7%89%88%EF%BC%89.png" style="height:43px;margin-left:22px;" alt="">
            <img v-if="['2023sz'].includes(global.year)" src="https://f.msup.com.cn/%E5%8D%8F%E4%BC%9Alogo%282023%29.png" style="height:32px;margin-left:15px;" alt="" >
          </div>
          <div class="qrcode-wrapper">
            <div>
              <img class="qrcode" src="../assets/img/footer_qrcode.png" alt="" />
            </div>
            <div class="contact-us mob">
              <h4>联系我们</h4>
              <p v-if="global.companyphone[0]!=1">详情咨询：{{global.companyphone}}</p>
              <p>赞助合作：sissi</p>
              <p>联系电话：130-4321-8801</p>
              <p>邮箱：market@msup.com.cn</p>
              <p>媒体合作：景怡</p>
              <p>联系电话：139-2085-9305</p>
              <p>邮箱：jingyi@msup.com.cn</p>
              <p>票务合作：祖丽</p>
              <p>联系电话：150-2204-3723</p>
              <p>邮箱：zuli@msup.com.cn</p>
            </div>
          </div>
        </div>
        <div class="company">
          <p>
            CopyRight © 2008-{{new Date().getFullYear()}} Msup & 高可用架构<br>
            <a href="https://www.cnzz.com/stat/website.php?web_id=4006688" target="_blank" title="站长统计">
              <img hspace="0" vspace="0" :src="iconImg" style="border:none;">
            </a>&nbsp;&nbsp;&nbsp;
            <a href="https://www.cnzz.com/stat/website.php?web_id=1274433542" target="_blank" title="站长统计">
              <img hspace="0" vspace="0" :src="iconImg" style="border:none;">
            </a>
          </p>
          <a href="http://www.beian.miit.gov.cn">
            <img width="18" height="18" style="height: 18px; padding-bottom: 0px" src="https://f.msup.com.cn/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png" />
            京ICP备09001521号
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // iconImg: 'https://icon.cnzz.com/img/pic1.gif',
      // iconImg: 'https://f.msup.com.cn/icon/icon.cnzz.com-img-pic1.gif'
      iconImg: 'https://f.msup.com.cn/icon/cnzz.gif',
    }
  }
}
// 站点 GIAC
// document.write(unescape("%3Cspan id='cnzz_stat_icon_1274433542'%3E%3C/span%3E%3Cscript src='https://s13.cnzz.com/stat.php%3Fid%3D1274433542%26show%3Dpic1' type='text/javascript'%3E%3C/script%3E"));
// 站点 MSUP
// document.write(unescape("%3Cspan id='cnzz_stat_icon_4006688'%3E%3C/span%3E%3Cscript src='https://s13.cnzz.com/stat.php%3Fid%3D4006688%26show%3Dpic1' type='text/javascript'%3E%3C/script%3E"));
</script>

<style lang="scss" scoped>
.giac-footer-con {
  width: 100vw;
  .giac-footer {
    // margin: 70px auto 54px;
    margin: 70px auto;
    margin-bottom: 0;
    padding-bottom: 70px;
    width: 100%;
    max-width: 1195px;
    &.year_2024sz {
      padding-bottom: 100px;
    }
    &.isclose {
      padding-bottom: 35px;
      animation: isclose 0.3s;
    }
    @keyframes isclose {
      0% { padding-bottom: 100px; }
      100% { padding-bottom: 35px; }
    }
    p {
      margin-bottom: 0;
    }
    .row {
      margin-left: 0;
      margin-right: 0;
    }
    .content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      h4 {
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        text-align: left;
        color: #000000;
        margin-bottom: 34px;
      }
      .related-course {
        text-align: left;
        .row {
          align-items: center;
          a {
            text-decoration: none;
            font-size: 16px;
            font-weight: 400;
            font-family: Source Han Sans CN;
            color: #666666;
            line-height: 36px;
            display: flex;
            align-items: center;
          }
        }
      }
      .contact-us {
        text-align: left;
        line-height: 36px;
        p {
          color: #666666;
          text-align: left;
          font-size: 16px;
          font-weight: 400;
          font-family: Source Han Sans CN;
        }
      }
      .sponsor {
        text-align: left;
        h4 {
          margin-bottom: 16px;
        }
        .qrcode-wrapper {
          margin-top: 18px;
          display: flex;
          flex-direction: row;
          p {
            margin-left: 19px;
            width: 112px;
            font-size: 14px;
            font-weight: 400;
            font-family: Source Han Sans CN;
            text-align: left;
            color: #000000;
            line-height: 18px;
            display: flex;
            flex-direction: column-reverse;
          }
        }
      }
    }
    .company {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Normal;
      text-align: left;
      color: #999999;
      line-height: 30px;
    }
  }
  @media (min-width: 1024px) {
    .mob { display: none; }
    .pc { display: block; }
  }
  @media (max-width: 1023px) {
    .pc { display: none; }
    .mob { display: block; }
    .giac-footer {
      width: 100vw;
      margin-top: 40px;
      // margin-bottom: 60px;
      padding-bottom: 60px;
      .content {
        display: flex;
        flex-direction: column;
        padding-left: 7vw;
        padding-right: 7vw;
        .sponsor {
          h4 {
            font-size: 16px;
            margin-bottom: 10px;
          }
          .qrcode-wrapper {
            .qrcode {
              max-width: 100%;
            }
            .contact-us {
              padding-left: 4vw;
              p {
                font-size: 12px;
                width: 100%;
                margin-left: 0;
              }
            }
            .logo {
              max-width: 100%;
            }
          }
        }
        .company {
          margin-top: 15px;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .giac-footer {
      &.year_2024sz {
        padding-bottom: 120px;
      }
      &.isclose {
        padding-bottom: 35px;
        animation: isclose 0.3s;
      }
      @keyframes isclose {
        0% { padding-bottom: 120px; }
        100% { padding-bottom: 35px; }
      }
    }
  }
}
</style>